export const getTimezoneOrDefault = (timezone?: string) => {
    // Valid timezone IANA strings are in the format "COUNTRY/CITY_OR_STATE", or the default value of "UTC".
    // IANA strings will be used as-is. Anything otherwise defaults to Pacific time.
    return timezone?.includes('/') ? timezone : 'America/Los_Angeles';
};
